import * as React from 'react';
import cn from 'classnames';
import { makeStyles, createStyles } from '@material-ui/core';
import { TranquiTheme } from '../../containers/App/theme';
import Alert, { AlertProps } from '../Alert/Alert';

export type AlertBaseType = 'alert' | 'restrictions' | 'rectictionsAccepted' | 'informative';
type AlertColorType = { [key in AlertBaseType]: AlertProps['color'] };

interface AlertBaseProps {
  type: AlertBaseType;
  className?: string;
  dataTest?: string;
  title?: string;
  filled?: boolean;
}

const AlertBase:React.FC<AlertBaseProps> = (props) => {
  const { className, children, type, dataTest, title, filled = true } = props;
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  const classes = useStyles();

  const isAlert = type === 'alert';

  const alertColors: AlertColorType = {
    alert: 'warning',
    restrictions: 'error',
    rectictionsAccepted: 'primary',
    informative: 'secondary',
  };

  return (
    <Alert
      color={alertColors[type]}
      iconColor={alertColors[type]}
      icon="info"
      filled={filled}
      className={cn(className, 'p-2', isAlert && classes.colorText)}
      data-test={dataTest}
      title={title || 'Importante'}
      titleClassName={cn(isAlert && classes.colorText)}
    >
      { children }
    </Alert>
  );
};

const useStyles = makeStyles((theme: TranquiTheme) => createStyles({
  colorText: {
    color: theme.palette.indigo.main,
  },
}));

export default AlertBase;
